import { type Device, type DeviceBase } from '@/entities/device';

import { FeApi } from '../..';

export function mapDeviceBase(data: {
  accure_id: string;
  full_frontend_id: string;
  level: string;
}): DeviceBase {
  return {
    id: data.accure_id,
    fullFrontendId: data.full_frontend_id,
    level: data.level,
  };
}

export function deviceMapper(data: FeApi.DeviceDetailsViewOutput): Device {
  return {
    id: data.accure_id,
    fullFrontendId: data.full_frontend_id,
    level: data.level,
    lineage: data.lineage?.map(mapDeviceBase) ?? [],
    frontendId: data.frontend_id,
  };
}
